import { Stack } from '@mui/material';
import CircularProgress from '../CircularProgress/CircularProgress';

const LoadingPage = () => {
  return (
    <Stack direction="column" justifyContent="center" alignItems="center">
      <CircularProgress size={120} />
    </Stack>
  );
};

export default LoadingPage;
